import { render, staticRenderFns } from "./DiscoverBtn.vue?vue&type=template&id=9932a128&"
import script from "./DiscoverBtn.vue?vue&type=script&lang=js&"
export * from "./DiscoverBtn.vue?vue&type=script&lang=js&"
import style0 from "./DiscoverBtn.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports